import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const getGptModels = () => {
  return axios.get(`${API_URL}/gptModelSettings/getAll`);
};

const updateGptModel = (formData) => {
  return axios.patch(`${API_URL}/gptModelSettings/update`, formData);
};

const getSavedGptModel = () => {
  return axios.get(`${API_URL}/gptModelSettings/getGptModel`);
};

const gptModelSettingsApi = {
  getGptModels,
  updateGptModel,
  getSavedGptModel,
};

export default gptModelSettingsApi;